import { useCallback } from 'react';
import { usePermissions } from '../../../hooks/usePermissions';
import { lmsAccess } from '../../../constants/permissionCodes';

// Sayfa içi (buton, kart, satır) LMS kontrolü: route ile aynı kural (yetki kodu VEYA eski kural)
export const useLmsPermission = () => {
    const { canViewMenuItem } = usePermissions();
    const can = useCallback((codes) => canViewMenuItem({ permissions: lmsAccess(Array.isArray(codes) ? codes : [codes]) }), [canViewMenuItem]);
    return { can };
};
